__turbopack_context__.v({
  "imageWrapper": "ImageWrapper-module__qIyGdq__imageWrapper",
  "isCompact": "ImageWrapper-module__qIyGdq__isCompact",
});
